module.exports = __webpack_public_path__ + "static/media/ids_logo.eb78b9a2.svg";